export class Alerter {
    constructor(options) {
        this.config = Alerter.mergeSettings(options);
        this.init();
    }

    static mergeSettings(options) {
        const settings = {
            title: '',
            text: '',
            cancelText: null,
            acceptText: null,
            onAccept: () => {
            },
            onCancel: () => {
            },
        };

        const userSttings = options;
        for (const attrname in userSttings) {
            settings[attrname] = userSttings[attrname];
        }

        return settings;
    }

    _button($text, $type, $id) {
        return `  
        <button id="${$id}" class=" btn btn-${$type}  d-flex  ">
            <div class="btn-arrow">
                <svg width="50px" height="50px" viewBox="0 0 50 50" version="1.1" xmlns="http://www.w3.org/2000/svg"
                     xmlns:xlink="http://www.w3.org/1999/xlink">
                    <g id="Symbols" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                        <path class="inline-svg"
                              d="M24.5639893,19 L26.9521116,19 L30.9973338,25.1216537 L26.9493623,31.2700005 L24.5639893,31.2700005 L28.6109479,25.1239623 L24.5639893,19 Z M19,19 L21.3879776,19 L25.4334892,25.1216537 L21.3849389,31.2700005 L19,31.2700005 L23.0469586,25.1239623 L19,19 Z"
                              id="Fill-1"></path>
                    </g>
                </svg>
            </div>
            <span>
                ${$text}
            </span>
        </button>`
    }

    _templateCancelButton() {
        if (this.config.cancelText == null) {
            return '';
        }

        return `
        <div class="col-auto">
            <div class="close">
                ${this._button(this.config.cancelText, 'secondary', 'cancel')}
            </div>
        </div>`;
    }

    _templateAcceptButton() {
        if (this.config.acceptText == null) {
            return '';
        }

        return `
        <div class="col-auto">
            <div class="accept">
                ${this._button(this.config.acceptText, 'success', 'accept')}
            </div>
        </div>`;
    }

    _templateBottomButton() {
        if (this.config.cancelText == null && this.config.acceptText == null) {
            return '';
        }

        return `
        <div class="row">
            ${this._templateCancelButton()}
            ${this._templateAcceptButton()}
        </div>`;
    }

    _template() {
        return `
        <div class="klinger-popup">
            <div class="klinger-popup__overlay close"></div>
            <div class="klinger-popup__holder">
                <h3 class="mb-5">
                    <strong>
                        ${this.config.title}
                    </strong>
                </h3>
                <div class="mb-5">
                    ${this.config.text}
                </div>
                ${this._templateBottomButton()}
            </div>
        </div>`
    }

    _remove() {
        document.querySelector('.klinger-popup').remove();
    }

    _close() {
        this.config.onCancel.call(this);
        this._remove();
    }

    _accept() {
        this.config.onAccept.call(this);
        this._remove();
    }

    init() {
        let createNode = document.createRange().createContextualFragment(this._template());
        setTimeout(() => {
            document.body.appendChild(createNode);
        }, 1);

        let close = createNode.querySelectorAll('.close');
        for (let $i = 0; $i < close.length; $i++) {
            close[$i].onclick = () => {
                this._close();
            };
        }

        let accept = createNode.querySelectorAll('.accept');
        for (let $i = 0; $i < accept.length; $i++) {
            accept[$i].onclick = () => {
                this._accept();
            };
        }

    }

}